// extracted by mini-css-extract-plugin
export default {"terms":"xIcLmy79qwO7xJTuoX2T"};